<script>
import VueEasyLightbox from "vue-easy-lightbox";
import {getImagePath} from "@/helpers/utils";

export default {
  components: {
    VueEasyLightbox
  },
  props: {
    page: {
      type: Object,
      default: null
    }
  },
  computed: {
    lightboxImgs() {
      return getImagePath(this.page, false);
    }
  },
  data() {
    return {
      singleImage: false
    };
  },
  methods: {
    getImagePath
  }
};
</script>

<template>
  <div class="page-image">
    <template v-if="page.image_available">
      <a href="javascript: void(0)" @click="singleImage = true">
        <b-card-img-lazy :src="getImagePath(page, true)[0].src" class="img-fluid"
                         :alt="page.NumPageAlbum"></b-card-img-lazy>
      </a>
      <vue-easy-lightbox :visible="singleImage" :imgs="lightboxImgs" @hide="singleImage = false"></vue-easy-lightbox>
    </template>
    <b-card-img-lazy v-else :src="require(`@/assets/images/missing-img.svg`)" class="img-fluid"
                     :alt="page.NumPageAlbum"></b-card-img-lazy>
  </div>
</template>
